import Component from '@glimmer/component';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import { eq } from 'ember-truth-helpers';

// Segmented Condensed / Regular / Relaxed control for stat-table row height.
// Persists via the density service (cookie + localStorage), exactly like the
// theme toggle. Purely a display preference — it retunes the --table-row-pad
// token and touches nothing else.
export default class DensityToggle extends Component {
  @service density;

  // Wrap so the service keeps its `this` when invoked from the template.
  select = (option) => this.density.set(option);

  <template>
    <div class='density-toggle' role='group' aria-label='Table density'>
      {{#each this.density.options as |option|}}
        <button
          type='button'
          class='density-toggle-btn {{if (eq this.density.density option) "is-active"}}'
          aria-pressed='{{if (eq this.density.density option) "true" "false"}}'
          {{on 'click' (fn this.select option)}}
        >
          {{option}}
        </button>
      {{/each}}
    </div>
  </template>
}
